import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AdminDashboard, AppRole } from 'src/app/shared/models/admin-dashboard.modal';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IMessage } from 'src/app/shared/models/message.modal';
import { MessageModalComponent } from 'src/app/shared/components/message-modal/message-modal.component';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../admin.service';

@Component({
    selector: 'app-dashboard-settings',
    templateUrl: './dashboard-settings.component.html',
    styleUrls: ['./dashboard-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardSettingsComponent implements OnInit {
  @Input() tabId: string;
  dashboardData: AdminDashboard[] = [];
  appRoles: AppRole[] = [];
  successMessage: IMessage;
  public updateSuccess: MatDialogRef<MessageModalComponent>;
  constructor(
    private adminService: AdminService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.fetchDashboardData();
  }

  fetchDashboardData(): void {
    this.adminService.getTabConfigItems(this.tabId)?.subscribe(
      (response: AdminDashboard[]) => {
        this.dashboardData = response.sort((a, b) => a.sortOrder - b.sortOrder);
      },
      (error) => {
        console.error('Error fetching tabs data:', error);
      },
    );
  }

  savebtn(): void {
    this.adminService.updateSettings(this.dashboardData, this.tabId)?.subscribe({
      next: (response: AdminDashboard[]) => {
        this.dashboardData = response;
        this.snackBar.open(messagesConfig.changeSuccessMeaage.message, 'DONE', {
          duration: 3000,
          verticalPosition: 'top',
          panelClass: ['default-snackbar'],
        });
        this.fetchDashboardData();
      },
      error: (err) => console.error('Error API:', err),
    });
  }
}
